import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import UserStatusBoolean from './userstatusboolean';
import RepresentationsList from './representationslist';

const styles = {
    field: { mb: 1.5 },
    label: {
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        fontSize: '0.72rem',
        fontWeight: 600,
    },
    value: { mt: 0.25 },
    divider: { my: 2 },
    editButton: { mt: 1 },
    emptyValue: { color: 'text.disabled', fontStyle: 'italic' },
};

function Field({ label, children }) {
    return (
        <Grid item xs={12} sm={6} sx={styles.field}>
            <Typography variant="caption" component="div" sx={styles.label}>
                {label}
            </Typography>
            <Typography variant="body2" component="div" sx={styles.value}>
                {children}
            </Typography>
        </Grid>
    );
}

function ChipList({ items, getKey, getLabel, color }) {
    if (!items || items.length === 0) {
        return <span style={styles.emptyValue}>-</span>;
    }
    return (
        <Stack direction="row" flexWrap="wrap" gap={0.5}>
            {items.map((item) => (
                <Chip key={getKey(item)} label={getLabel(item)} size="small" color={color} variant="outlined" />
            ))}
        </Stack>
    );
}

export default function UserView(props) {
    const user = props.user;

    const onEdit = () => {
        props.history.push('/admin/user/edit/' + user.id);
    };

    if (!user) {
        return <Grid container />;
    }

    return (
        <Grid container>
            <Grid item container>
                <Field label="Tila">
                    <UserStatusBoolean status={{ enabled: user.enabled, amazonStatus: user.amazonStatus }} />
                </Field>

                <Field label="Käyttäjänimi">{user.username}</Field>

                <Field label="Nimi">{user.name}</Field>

                <Field label="Puhelin">{user.phoneNumber || <span style={styles.emptyValue}>-</span>}</Field>

                <Field label="Roolit">
                    <ChipList items={user.roles} getKey={(r) => r} getLabel={(r) => r} color="primary" />
                </Field>

                {!user.isCustomerUser && (
                    <>
                        <Field label="Salkut">
                            <ChipList items={user.portfolios} getKey={(p) => p.id} getLabel={(p) => p.name} />
                        </Field>

                        <Field label="Yritykset">
                            <ChipList
                                items={user.tenantCompanies}
                                getKey={(tc) => tc.clusterId}
                                getLabel={(tc) => tc.name}
                            />
                        </Field>
                    </>
                )}

                {user.isCustomerUser && (
                    <Grid item xs={12} sx={styles.field}>
                        <Typography variant="caption" component="div" sx={styles.label}>
                            Edustaa
                        </Typography>
                        <RepresentationsList representations={user.representations} allowEdit={false} />
                    </Grid>
                )}

                <Grid item xs={12}>
                    <Divider sx={styles.divider} />
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        name="btn-open-edit"
                        startIcon={<EditIcon fontSize="small" />}
                        sx={styles.editButton}
                        onClick={onEdit}>
                        Muokkaa
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    );
}
